<div
  class="inline-flex rounded-lg p-1 gap-0.5"
  [class]="framed() ? 'border border-border-card bg-surface-card' : 'bg-gray-100'"
>
  @for (option of options(); track option) {
    <button
      type="button"
      class="px-4 py-1.5 text-sm font-medium rounded-md transition-colors cursor-pointer"
      [class.bg-primary]="selected() === option"
      [class.text-white]="selected() === option"
      [class.text-gray-600]="selected() !== option && !framed()"
      [class.text-text-secondary]="selected() !== option && framed()"
      (click)="selectedChange.emit(option)"
    >
      {{ 'general.' + option | translate }}
    </button>
  }
</div>
